import { render, staticRenderFns } from "./GetStartedModal.vue?vue&type=template&id=62507158&"
import script from "./GetStartedModal.vue?vue&type=script&lang=ts&"
export * from "./GetStartedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
